import { render, staticRenderFns } from "./complexTodo-new.vue?vue&type=template&id=620a3e7c&scoped=true"
import script from "./complexTodo-new.vue?vue&type=script&lang=js"
export * from "./complexTodo-new.vue?vue&type=script&lang=js"
import style0 from "./complexTodo-new.vue?vue&type=style&index=0&id=620a3e7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620a3e7c",
  null
  
)

export default component.exports